// <afo-projects> — Projects sayfası etkileşimleri (2026-09-08).
// 1) Kaydırmayla belirme: [data-afo-reveal] görünüme girince .is-inview
// 2) Bant paralaksı: [data-afo-parallax] içindeki görsel scroll'la hafif kayar
// Reduced-motion'da ikisi de devre dışı (CSS zaten statik hale getirir).

if (!customElements.get('afo-projects')) {
  customElements.define(
    'afo-projects',
    class AfoProjects extends HTMLElement {
      #observer = null;
      #bands = [];
      #ticking = false;
      #reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

      connectedCallback() {
        if (this.#reduced.matches) {
          this.querySelectorAll('[data-afo-reveal]').forEach((el) => el.classList.add('is-inview'));
          return;
        }

        this.#observer = new IntersectionObserver(
          (entries) => {
            for (const e of entries) {
              if (e.isIntersecting) {
                e.target.classList.add('is-inview');
                this.#observer.unobserve(e.target);
              }
            }
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.08 }
        );
        this.querySelectorAll('[data-afo-reveal]').forEach((el) => this.#observer.observe(el));

        this.#bands = [...this.querySelectorAll('[data-afo-parallax] .afo-projects__band-img')];
        if (this.#bands.length) {
          window.addEventListener('scroll', this.#onScroll, { passive: true });
          this.#applyParallax();
        }
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
        window.removeEventListener('scroll', this.#onScroll);
      }

      #onScroll = () => {
        if (this.#ticking) return;
        this.#ticking = true;
        requestAnimationFrame(() => {
          this.#applyParallax();
          this.#ticking = false;
        });
      };

      #applyParallax = () => {
        for (const img of this.#bands) {
          const kap = img.parentElement.getBoundingClientRect();
          if (kap.bottom < 0 || kap.top > window.innerHeight) continue;
          // kapsayıcının viewport içindeki ilerlemesi: -1 (altta) → 1 (üstte)
          const oran = (kap.top + kap.height / 2 - window.innerHeight / 2) / (window.innerHeight / 2 + kap.height / 2);
          img.style.transform = `translateY(${(-oran * 6).toFixed(2)}%)`;
        }
      };
    }
  );
}
